__webpack_require__.p = "/news_react_app/";